import React, { useEffect, useState } from "react";
import {
  Button,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  MenuItem,
  Autocomplete,
  Grid,
  Paper,
} from "@mui/material";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import * as Yup from "yup";
import { es } from "date-fns/locale";
import Iconify from "../../../../components/Iconify";
import {
  CREAR_EGRESO,
  OBTENER_EGRESOS_DIA,
  OBTENER_CAT_EGRESOS,
  OBTENER_SUB_EGRESOS,
} from "../../../../graphql/egresos";
const FrmAgregarEgreso = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  const [detalleid, setDetalleId] = useState("")
  const { data, loading, error } = useQuery(OBTENER_CAT_EGRESOS);
  const [obtenerDetallesEgresos, { data: d, loading: l, error: e }] = useLazyQuery(OBTENER_SUB_EGRESOS, {


  })
  const [crearEgreso] = useMutation(CREAR_EGRESO, {
    update(cache, { data: { crearEgreso } }) {
      const { obtenerEgresos } = cache.readQuery({
        query: OBTENER_EGRESOS_DIA,
      });

      cache.writeQuery({
        query: OBTENER_EGRESOS_DIA,
        data: {
          obtenerEgresos: [...obtenerEgresos, crearEgreso],
        },
      });
    },
  });


  const formik = useFormik({
    initialValues: {
      descripcion: "",
      archivo: null,
      fechaEgreso: "",
      CatEgresosId: "",
      detalleEgresoId: "",
      monto: "",
    },
    validationSchema: Yup.object({
      monto: Yup.number()
        .required("El monto no puede ser cero")
        .test(
          "Monto no valido",
          "El monto no puede ser cero",
          (value) => value > 0
        ),
    }),
    onSubmit: async (inputData) => {
      try {

        const result = await crearEgreso({
          variables: {
            input: {
              descripcion: inputData.descripcion,
              fechaEgreso: inputData.fechaEgreso,
              CatEgresosId: inputData.CatEgresosId,
              detalleEgresoId: inputData.detalleEgresoId
            },
            cobro: {
              monto: parseFloat(inputData.monto),
            },
            archivo: inputData.archivo,
          },
        });
        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.crearEgreso,
          severity: "success",
        });
        formik.resetForm();
        resetFechas();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });
  useEffect(() => {
    console.log(formik.values.CatEgresosId)
    if (formik.values.CatEgresosId == "") {
      setDetalleId("")
    } else {
      setDetalleId(formik.values.CatEgresosId)
    }
    obtenerDetallesEgresos({
      variables: {
        CatEgresos: detalleid
      }
    })
  }, [setDetalleId, detalleid, formik.values.CatEgresosId])



  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };

  const resetFechas = () => {
    formik.setFieldValue("fechaEgreso", null);
    // formik.values.fechaEgreso= "";
  };





  if (loading) return <h1>Cargando...</h1>;
  const { obtenerCategoriasEgresos } = data;
  if (l) return

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                name="CatEgresosId"
                select
                label="Tipo de Egreso"
                helperText="Seleccione una categoría para este registro"
                variant="standard"
                fullWidth
                value={formik.values.CatEgresosId}
                onChange={formik.handleChange}
              // onChange={e => handleSubcategoria(e.target.value)}
              >
                {obtenerCategoriasEgresos.map((options) => (
                  <MenuItem key={options.clave} value={options.clave}>
                    {options.clave}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                name="detalleEgresoId"
                select
                label="Subtipo de Egreso"
                helperText="Selecciona un subtipo para el egreso"
                value={formik.values.detalleEgresoId}
                onChange={formik.handleChange}
                variant="standard" fullWidth>
                {d.obtenerDetallesEgresos.map((options) => (
                  <MenuItem key={options.clave} value={options.clave}>
                    {options.clave} - {options.descripcion}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" component="label">
                Subir archivo
                <input
                  hidden
                  id="archivo"
                  name="archivo"
                  type="file"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "archivo",
                      event.currentTarget.files[0]
                    );
                  }}
                />
              </Button>
              Subir archivo: <label>{formik.values.archivo?.name}</label>
              {formik.errors.archivo}
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDateFns}>
                <DatePicker
                  onChange={(date) => formik.setFieldValue("fechaEgreso", date)}
                  value={formik.values.fechaEgreso}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="fechaEgreso"
                      fullWidth
                      variant="standard"
                      label="Fecha de Egreso"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          

            <Grid item xs={12} md={12} lg={6}>
              {" "}
              <TextField
                label="Monto"
                variant="standard"
                name="monto"
                type={"number"}
                spacing={4}
                onChange={formik.handleChange}
                value={formik.values.monto}
              />
              {formik.errors.monto}
            </Grid>
            


            <Grid item xs={12} md={12} lg={6}>
              <Button
                type="submit"
                startIcon={<Iconify icon="eva:save-outline" />}
              >
                Guardar
              </Button>
              <Button
                onClick={() => handleOpenDialog()}
                color="error"
                startIcon={<Iconify icon="eva:close-outline" />}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </>
  );
};

export default FrmAgregarEgreso;
